
// "use strict";
import 'regenerator-runtime/runtime'
//1. Initialization
import "../scss/style.scss";
import { Tooltip, Toast,Modal,Offcanvas  } from 'bootstrap';
import axios from "axios";
import { gsap } from "gsap";


// AOS.init();

let isClosed = false;
let lastScrollTop = 0;
let body=document.querySelector("body");
let burgerMenu = document.querySelector("#hamburger")
let btnLanguage=document.querySelectorAll('.navbar-custom__btn-language');
let btnToggler=document.querySelector('.navbar-custom__toggler');
let offcanvasTop=document.querySelector('#offcanvasTop');
let modalLanguage = new Modal(document.getElementById('modalLanguage'), {
    keyboard: true,
    //backdrop: 'static',
})
let modalThakyou = new Modal(document.getElementById('modalThankyou'), {
    keyboard: true,
    //backdrop: 'static',
})
let bsOffcanvas = new Offcanvas(offcanvasTop)
let tabMobileLinks=document.querySelectorAll('.navbar-custom__tab-mobile-link');
let navbarCustomSearchInput=document.querySelector('.navbar-custom__search-input');
let navbarCustomSearchIcon=document.querySelector('.navbar-custom__search-icon');

let searchHolderMobile=document.querySelector('.mobile-menu__search-container');
let searchHolderDesktop=document.querySelector('.navbar-custom__desktop-search');
let searchFormGeneral=document.querySelector('.navbar-custom__search-container');


let scrolltopBtn=document.querySelector('#scrolltop-btn');
let whatappBtn=document.querySelector('#whatapp-btn'); 
let preloader=document.querySelector('.preloader');

for (const tabMobileLink of tabMobileLinks) {
    tabMobileLink.addEventListener('click', function onClick() {
        let tabID=tabMobileLink.dataset.id
        let tabBG=tabMobileLink.dataset.bg
        removeBGNavTab();
        tabMobileLink.style.background=tabBG
    });
}

function removeBGNavTab(){
    tabMobileLinks.forEach(tabMobileLink => {
        tabMobileLink.style.background='#ffffff';
    });
}


//2. Event Area 
offcanvasTop.addEventListener('hidden.bs.offcanvas', function () {
    closeSideMenu();
})

btnLanguage.forEach(n => n.addEventListener('click', ()=>{  
    modalLanguage.show();
}))

btnToggler.addEventListener('click', ()=>{  
    burgerTime() 
});

scrolltopBtn.addEventListener('click', ()=>{  
    scrollToTop();
});


onscroll = (event) => { 
    const navHeader = document.querySelector('.navbar-custom');
    let currentScrollPos = window.scrollY;
    let scrollToTopBtn=document.querySelector('.scrolltop-btn')
    let whatappBtn=document.querySelector('.whatapp-btn')
    let promoModalBtn=document.querySelector('.promoModal-btn')
    setTimeout(function(){
        if(currentScrollPos<=0){
            navHeader.classList.remove('hide');
            navHeader.classList.remove('show');
        }
        else if(currentScrollPos > lastScrollTop){
            navHeader.classList.add('hide');
            navHeader.classList.remove('show');
        } else {
            navHeader.classList.add('show');
            navHeader.classList.remove('hide');
        }
        lastScrollTop = currentScrollPos;
    }, 100);

    if(currentScrollPos>750){
        scrollToTopBtn.classList.add('active')
        whatappBtn.classList.add('active')
        promoModalBtn.classList.add('active')
    }else{
        scrollToTopBtn.classList.remove('active')
        whatappBtn.classList.remove('active')
        promoModalBtn.classList.remove('active')
    }
};

window.addEventListener("load", function () {
    let wpcf7=document.querySelector(".wpcf7");
    if(wpcf7){
        wpcf7.addEventListener(
            "wpcf7mailsent",
            function (event) {
                modalThakyou.show();
            },
            false
        );
    }
    if (window.innerWidth <= 767) {
        searchHolderMobile.append(searchFormGeneral)
	} else {
		searchHolderDesktop.append(searchFormGeneral)
	}
});

document.addEventListener("DOMContentLoaded", function(){
    gsap.fromTo(
        ".preloader",
        { duration:1, autoAlpha:1},
        { duration:1, autoAlpha:0}
    );
});


window.addEventListener("resize", function(){
    if (window.innerWidth <= 767) {
        searchHolderMobile.append(searchFormGeneral)
	} else {
		searchHolderDesktop.append(searchFormGeneral)
	}
});

navbarCustomSearchInput.onkeyup = (e)=>{
    let searchAutocomplateBox=document.querySelector('.navbar-custom__search-autocomplate');
    let userData = e.target.value; //user enetered data
    // console.log(userData);
    if(userData || userData!=''){
        getResults(userData);
        searchAutocomplateBox.classList.add("active");
        navbarCustomSearchInput.classList.add("active");
        navbarCustomSearchIcon.classList.add("active");
    }else{
        searchAutocomplateBox.classList.remove("active");
        navbarCustomSearchInput.classList.remove("active");
        navbarCustomSearchIcon.classList.remove("active");
    }
}

//3. Function Area
function burgerTime() {
    if (isClosed== true) {
        closeSideMenu();
    } else {
        openSideMenu()
    }
}

function openSideMenu(){
    burgerMenu.classList.remove("closed");
    burgerMenu.classList.add("open");
    body.classList.add('no-scroll');
    bsOffcanvas.show();
    isClosed = true;
}

function closeSideMenu(){
    burgerMenu.classList.remove("open");
    burgerMenu.classList.add("closed");
    body.classList.remove('no-scroll');
    bsOffcanvas.hide();
    isClosed  = false;
}

function scrollToTop(){
    window.scroll({top:0, behavior:'smooth'});
}


async function getResults(data) {
    try {
        const response = await axios.get(appData.root_url + "/wp-json/tmdr/v1/search?term=" + data)
        const results = response.data.generalInfo
        if(results.length>0){
            const ul = document.getElementById('search-list');
            ul.innerHTML='';
            results.forEach((result) => {
                const li = `<li class="navbar-custom__search-item">
                    <a class="navbar-custom__search-link" href="${result.permalink}">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6" cy="6" r="5.5" stroke="#08381D"/>
                            <path d="M6 2.14282V5.99996L8.57143 8.57139" stroke="#08381D"/>
                        </svg>
                        ${result.title}
                    </a>
                </li>`
                ul.innerHTML += li
            })
        }else{
            ul.innerHTML="";
        }
    } catch (e) {
        console.log('seacrh not found')
    }
}